// extracted by mini-css-extract-plugin
export var defaultWrapper = "_i8-3";
export var downloadButton = "_i8-4";
export var fileContainer = "_i8-9 _i8-7";
export var fileContainerBase = "_i8-7";
export var fileContainerBaseSm = "_i8-a _i8-7";
export var fileContainerFixedHeight = "_i8-8 _i8-7";
export var fileContainerFixedHeightSm = "_i8-c _i8-a _i8-7";
export var fileContainerSm = "_i8-b _i8-a _i8-7";
export var fileInfo = "_i8-5";
export var fileInfoWidthRestricted = "_i8-6";
export var fileType = "_i8-1";
export var fileTypeName = "_i8-2";
export var fileTypeSm = "_i8-d _i8-1";
export var image = "_i8-0";
export var link = "_i8-f";
export var overflowEllipsis = "_i8-e";